'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of exclamation
 */ const Exclamation = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 105 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.6016",
                cy: "52.1016",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.5611",
                cy: "49.8052",
                r: "27.3619",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M28.2031 78.2378L31.8514 65.5762L39.2552 72.3362L28.2031 78.2378Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M31.7675 69.8126L32.8983 65.8664L31.3906 63.6466L33.6405 62.4043L41.2864 70.3378L40.9705 72.3L39.0756 71.2473L35.391 73.2475L31.7675 69.8126Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "47.8125",
                y: "30.1895",
                width: "8.50261",
                height: "29.1329",
                rx: "4.2513",
                transform: "rotate(-0.171913 47.8125 30.1895)",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.1061",
                cy: "65.6078",
                r: "4.28077",
                transform: "rotate(-0.171913 52.1061 65.6078)",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.Exclamation = Exclamation;
//# sourceMappingURL=Exclamation.cjs.map
